import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./src/components/Upload/js/bus2.js